import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/Warning';
//
//
// Falcon keeps its original hardcoded layout (renderFalcon, do not touch).
// Every other station gets the generic layout (renderGeneric), which builds the
// rows with calcGasFormula / calcNewGasFormula from the quoted price's frozen
// data dump, the same rows the /formulas page shows.
//
//

import StationInvoiceContainer from '../../containers/accounting/StationInvoice';
import pfLogo from '../../images/pearsonFuelsLogoV2.png';
import { calcGasFormula, calcNewGasFormula } from '../../libs/formulas';

const styles = () => {
	const p = (v) => {
		return `${v * 100}%`;
	};
	const pBlue = '#0790CB';
	const lineColor = '#D9D9D9';
	const rowLineColor = '#f1f1f1';

	return {
		root: {
			position: 'absolute',
			backgroundColor: 'white',
			height: '100%',
			width: '100%',
		},
		container: {
			position: 'relative',
			height: '100%',
			width: '100%',
			padding: `${p(0.065)} ${p(0.075)}`,
			boxSizing: 'border-box',
			fontFamily: 'Roboto',
			color: '#666',
			fontSize: '1.8vw',
		},
		containerWrapper: {
			position: 'relative',
			height: '100%',
			width: '100%',
			//border : '1px solid red',
		},

		logo: {
			marginTop: p(0.02),
			width: p(0.52),
			//height : p(0.),
		},

		formulaName: {
			fontSize: '130%',
			fontWeight: 900,
		},
		formulaUpdated: {
			fontWeight: 200,
			color: '#999',
		},
		formulaTitle: {
			textTransform: 'uppercase',
			color: '#999',
			paddingBottom: 10,
		},
		formulaRow: {
			display: 'flex',
			flexDirection: 'row',
			paddingBottom: 2,
		},
		formulaTotal: {
			borderTop: '2px solid #ccc',
			paddingTop: '5px',
			marginTop: '5px',
			display: 'flex',
			flexDirection: 'row',
			fontWeight: '800',
			paddingBottom: '15px',
		},
		formulaSubtotal: {
			marginLeft: '10%',
			marginRight: '10%',
			borderTop: '1px solid #ddd',
			paddingTop: '5px',
			marginTop: '5px',
			paddingBottom: '15px',
			display: 'flex',
			flexDirection: 'row',
			fontWeight: '800',
		},
		bigInvoiceContainer: {
			marginTop: '9%',
			borderTop: `1px solid ${lineColor}`,
			borderBottom: `1px solid ${lineColor}`,
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			padding: '1% 0%',
			lineHeight: '1.4',
		},
		bigInvoice: {
			fontSize: '6.2vw',
			fontWeight: 100,
			color: pBlue,
			flexBasis: '50%',
		},
		billingInfo: {
			textAlign: 'left',
			marginRight: '3%',
			flexBasis: '50%',
		},
		label: {
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
		},
		itemSection: {
			marginTop: '12%',
			width: '60%',
			marginLeft: '25%',
			fontSize: '100%',
		},
		labelLine: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderBottom: `1px solid ${lineColor}`,
			paddingBottom: '.4vw',
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
			textTransform: 'uppercase',
		},
		colDescription: {
			flexBasis: '80%',
			textAlign: 'left',
		},
		colQuantity: {
			flexBasis: '20%',
			textAlign: 'right',
		},
		colUnitCost: {
			flexBasis: '20%',
			textAlign: 'right',
		},
		colSubTotal: {
			flexBasis: '20%',
			textAlign: 'right',
		},
		itemRow: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${rowLineColor}`,
			paddingTop: '.9vw',
			paddingBottom: '.9vw',
			//letterSpacing : '.1em',

			paddingRight: '1vw',
			paddingLeft: '1vw',
		},

		rowSubTotal: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${lineColor}`,
			paddingTop: '.9vw',
			paddingBottom: '.9vw',
			//letterSpacing : '.1em',
			fontWeight: 900,
			marginBottom: '2vw',

			paddingRight: '1vw',
			paddingLeft: '1vw',
		},

		rowTotal: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${pBlue}`,
			paddingTop: '1.5vw',
			paddingBottom: '1.5vw',
			//letterSpacing : '.1em',
			fontWeight: 900,
			marginBottom: '2vw',
			fontSize: '110%',
			backgroundColor: '#f8f8f8',
			paddingRight: '1vw',
			paddingLeft: '1vw',
		},

		miniTotalSection: {
			display: 'flex',
			flexDirection: 'row',
			textAlign: 'right',
			justifyContent: 'flex-end',
			marginTop: '3%',
		},
		poInfo: {
			marginTop: '6%',
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
		},
		poGroup: {
			flexGrow: 1,
			marginRight: '6%',
			'&:last-child': {
				marginRight: '0%',
			},
		},
		poLabel: {
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
			borderBottom: `1px solid ${lineColor}`,
			paddingBottom: '.4vw',
			textTransform: 'uppercase',
			marginBottom: '.5vw',
		},

		formulaLabel: {
			color: '#333',
			flexBasis: '50%',
			textAlign: 'right',
			paddingRight: '8px',
		},
		formulaValue: {
			color: '#666',
			flexBasis: '50%',
			textAlign: 'left',
		},

		bottomSection: {
			position: 'absolute',
			bottom: '0%',
			width: '100%',
			marginBottom: '2%',
		},

		termAndTotal: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			marginTop: '.8%',
		},
		termParagraph: {
			fontSize: '92%',
			color: '#999999',
			textAlign: 'left',
			fontWeight: 200,
			flexBasis: '100%',
		},

		//- Generic (non-Falcon) formula sheet: tighter rows so long formulas fit one page
		itemSectionGeneric: {
			marginTop: '2%',
			width: '70%',
			marginLeft: '15%',
			fontSize: '82%',
		},
		itemRowGeneric: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${rowLineColor}`,
			paddingTop: '.32vw',
			paddingBottom: '.32vw',
			paddingRight: '1vw',
			paddingLeft: '1vw',
		},
		rowSubTotalGeneric: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${lineColor}`,
			paddingTop: '.32vw',
			paddingBottom: '.32vw',
			fontWeight: 900,
			marginBottom: '.6vw',
			paddingRight: '1vw',
			paddingLeft: '1vw',
		},
		rowTotalGeneric: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${pBlue}`,
			paddingTop: '.6vw',
			paddingBottom: '.6vw',
			fontWeight: 900,
			marginTop: '.6vw',
			fontSize: '110%',
			backgroundColor: '#f8f8f8',
			paddingRight: '1vw',
			paddingLeft: '1vw',
		},
		rowTitleGeneric: {
			display: 'flex',
			flexDirection: 'row',
			textAlign: 'left',
			borderBottom: `1px solid ${lineColor}`,
			textTransform: 'uppercase',
			paddingTop: '1.1vw',
			paddingBottom: '.25vw',
			marginBottom: '.4vw',
			color: '#555',
			fontSize: '90%',
			paddingRight: '1vw',
			paddingLeft: '1vw',
		},
		formulaNotes: {
			fontSize: '80%',
			color: '#999',
			textAlign: 'left',
			marginTop: '1.5vw',
		},
		warning: {
			color: '#FFC107',
			width: 14,
			height: 14,
			paddingRight: 3,
		},
		confidentialNote: {
			marginTop: '1%',
			fontSize: '85%',
			color: '#999999',
			textAlign: 'left',
			fontWeight: 400,
			fontStyle: 'italic',
		},
	};
};

class StationInvoice extends Component {
	constructor(props) {
		super(props);
		const stationInvoiceId = _.get(this.props, ['match', 'params', 'stationInvoiceId']);
		const securityHash = _.get(this.props, ['match', 'params', 'securityHash']);

		this.state = {
			stationInvoiceId: stationInvoiceId ? parseInt(stationInvoiceId, 10) : undefined,
			securityHash,
			errors: [],
		};
	}

	componentDidMount() {
		//- Only used for updates
		const { publicGetStationInvoice, stationInvoice } = this.props;
		const { stationInvoiceId, securityHash } = this.state;
		if (stationInvoice) {
			return;
		}

		publicGetStationInvoice({
			params: {
				stationInvoiceId,
				securityHash,
				includeQuickbooksCustomers: true,
				includeQuickbooksTerms: true,
			},
		});

		/*
			callback : (err, r) => {
				if (err) { return this.setState({ errors : [err] }); }
				const stationInvoice = _.get(r, ['collections', 'stationInvoiceCollection', 0]);
				if (!stationInvoice) { return {errors : ['Missing station invoice.']}; }




				return this.setState({ stationInvoice });
			}
		});
			*/
	}

	getDataDumpData = () => {
		const { stationInvoice, stationQuotedPriceMap, dataDumpMap } = this.props;

		if (!stationInvoice) {
			return { error: 'Missing station invoice. Contact support.' };
		}

		const { stationQuotedPriceId } = stationInvoice;
		if (!stationQuotedPriceId) {
			return { error: 'Missing quoted price. Contact support.' };
		}

		const stationQuotedPrice = stationQuotedPriceMap[stationQuotedPriceId];

		if (!stationQuotedPrice) {
			return { error: 'Could not find station quoted price in map. Contact support.' };
		}

		const { dataDumpId } = stationQuotedPrice;
		if (!dataDumpId) {
			return { error: 'Quoted price missing data dump. This estimate cant be used. Sorry.' };
		}

		const dataDump = dataDumpMap[dataDumpId];
		if (!dataDump) {
			return { error: 'Could not get data from dataDumpMap' };
		}

		return { data: dataDump.data, stationQuotedPrice };
	};

	render() {
		const { classes, stationInvoice, gasFormulaMap } = this.props;

		if (!stationInvoice) {
			return <div>Fetching station invoice...</div>;
		}

		const { error, data, stationQuotedPrice } = this.getDataDumpData();

		if (error) {
			return (
				<div>
					<div>Encountered an error when retrieving the data for formula</div>
					<div>{error}</div>);
				</div>
			);
		}

		const gasFormula = gasFormulaMap[stationQuotedPrice.gasFormulaId];
		const isFalcon = gasFormula && gasFormula.formulaKey === 'falconFormula';

		if (isFalcon) {
			return this.renderFalcon({ classes, data });
		}
		return this.renderGeneric({ classes, data, stationQuotedPrice, gasFormula });
	}

	//- Original Falcon-only sheet. Falcon keeps this exact layout, do not touch.
	renderFalcon = ({ classes, data }) => {
		const _f = (v) => {
			return parseFloat(v.toFixed(5));
		};

		const laEth = _f(data.laEth);
		const etohAdjustment = 0.15; // etoh adjustment
		const ethSubtotal = _f(laEth + etohAdjustment);

		//const c = (a + b) * 0.83;
		const ubdRackAvg = _f(data.ubdRackAvg);
		const capAtTheRack = _f(data.capAtTheRack);
		const lcfsCost = _f(data.lcfsCost);
		const unlSubtotal = _f(data.ubdRackAvg + data.capAtTheRack + data.lcfsCost);

		const ethSubtotalP = _f(ethSubtotal * 0.83);
		const unlSubtotalP = _f(unlSubtotal * 0.17);
		const adjustment = 0.08;
		const total = _f(ethSubtotalP + unlSubtotalP - adjustment);

		// Create our number formatter.
		const moneyFormatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 4,
			// the default value for minimumFractionDigits depends on the currency
			// and is usually already 2
		});

		const lineItems = [
			{ description: 'LA Spot Ethanol Cost', value: laEth },
			{ description: 'ETOH Adjustment', value: etohAdjustment },
			{ description: 'Subtotal A', value: ethSubtotal, isSubtotal: true },

			{ description: 'LA Carb 87 Rack Average', value: ubdRackAvg },
			{ description: 'LA Cap & Trade Midrange', value: capAtTheRack },
			{ description: 'LA LCFS Cost', value: lcfsCost },
			{ description: 'Subtotal B', value: unlSubtotal, isSubtotal: true },

			{ description: 'Subtotal A x 0.83', value: ethSubtotalP },
			{ description: 'Subtotal B x 0.17', value: unlSubtotalP },
			{ description: 'Adjustment', value: adjustment },
			{ description: 'Wholesale E85 Price', value: moneyFormatter.format(total), isTotal: true },
		];

		return (
			<div className={classes.root}>
				<div className={classes.container}>
					<div className={classes.containerWrapper}>
						<img alt="Logo" className={classes.logo} src={pfLogo} />

						<div className={classes.bigInvoiceContainer}>
							<div className={classes.bigInvoice}>FORMULA</div>
							<div className={classes.billingInfo}>
								<div className={classes.formulaName}>E85 Pricing Formula for Falcon Fuels</div>
								<div className={classes.formulaUpdated}>Updated to include LCFS fee expense</div>
								<div className={classes.formulaUpdated}>Revision Date: 3/16/2016</div>
							</div>
						</div>

						<div className={classes.itemSection}>
							<div className={classes.labelLine}>
								<div className={classes.colDescription}>DESCRIPTION</div>
								<div className={classes.colQuantity}>VALUE</div>
							</div>

							{lineItems.map((lineItem, i) => {
								const { description, value, isTotal, isSubtotal } = lineItem;

								const className = isSubtotal ? 'rowSubTotal' : isTotal ? 'rowTotal' : 'itemRow';

								return (
									<div key={i} className={classes[className]}>
										<div className={classes.colDescription}>{description}</div>
										<div className={classes.colQuantity}>{value}</div>
									</div>
								);
							})}
						</div>

						<div className={classes.bottomSection}>
							<div className={classes.labelLine}>
								<div>Terms &amp; Conditions</div>
							</div>
							<div className={classes.termAndTotal}>
								<div className={classes.termParagraph}>
									- Freight will be charged additional (Freight is often slightly more than common
									carriers due to the fact that the truck must make two stops at two fuel racks).
									<br />
									<br />- Prices do not include any taxes including the $.09 Vendor Use Tax that is
									to be paid when the E85 is dispensed into the vehicles.
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};

	//- Generic sheet for stations with includeFormulaBreakdownOnInvoices: same rows
	//- the /formulas page shows, built from the quoted price's frozen data dump
	renderGeneric = ({ classes, data, stationQuotedPrice, gasFormula }) => {
		const { stationMap, stationInvoice, rackFormulaMap } = this.props;

		const renderError = (error) => {
			return (
				<div>
					<div>Encountered an error when retrieving the data for formula</div>
					<div>{error}</div>
				</div>
			);
		};

		if (!gasFormula) {
			return renderError(`Gas formula ${stationQuotedPrice.gasFormulaId} not found.`);
		}

		const { formulaKey, isNewFormula, display } = gasFormula;
		const station = stationMap[stationInvoice.stationId] || {};
		const quotedPrice = stationQuotedPrice.price;
		const freight = stationQuotedPrice.freight || 0;

		let r;
		if (isNewFormula) {
			//- New-retail formulas have a freight row built in, so the quoted freight
			//- flows through the calc itself
			r = calcNewGasFormula({ data, formulaKey, freightPerGallon: freight });
		} else {
			const rackFormula = rackFormulaMap[stationQuotedPrice.rackFormulaId];
			if (!rackFormula) {
				return renderError(`Rack formula ${stationQuotedPrice.rackFormulaId} not found.`);
			}
			r = calcGasFormula({ data, formulaKey, rackFormulaKey: rackFormula.formulaKey });
		}

		if (r.notImplemented) {
			return renderError(`The ${display} formula breakdown has not been implemented yet.`);
		}

		let formulaRows = _.isArray(r.formulaRows) ? r.formulaRows : [];
		const formulaNotes = _.isArray(r.formulaNotes) ? r.formulaNotes : [];

		//- Reconcile the sheet to the invoiced price: the quoted price adds the RIN
		//- cost adder (flagged stations) and, for most old formulas, the freight
		//- delivery adder on top of the formula price. Only rewrite the total when
		//- the composition matches the quoted price exactly; otherwise leave the
		//- plain formula rows untouched.
		const rinCostAdder = station.applyRinCostAdderToFormula ? data.rinCostAdder || 0 : 0;
		if (_.isNumber(r.e85Price) && _.isNumber(quotedPrice)) {
			const freightCandidates = isNewFormula ? [0] : [freight, 0];
			for (const extraFreight of freightCandidates) {
				const total = r.e85Price + rinCostAdder + extraFreight;
				if (Math.abs(total - quotedPrice) < 0.0001) {
					const rows = formulaRows.filter((row) => !row.isTotal);
					if (rinCostAdder) {
						rows.push({ label: 'RIN Cost Adder', value: rinCostAdder });
					}
					if (extraFreight) {
						rows.push({ label: 'Freight per gallon', value: extraFreight });
					}
					rows.push({ label: 'E85 Price', value: quotedPrice, isTotal: true });
					formulaRows = rows;
					break;
				}
			}
		}

		//- Customer-facing sheet: hide the internal formula-name header rows (e.g.
		//- "Formula 15 E85 Formula", "Kinergy Ethanol Cost Formula"); generic
		//- section titles like "OPIS Inputs" stay.
		formulaRows = formulaRows.filter((row) => {
			return !(row.isTitle && (row.label || '').includes('Formula'));
		});

		const pricedDate = stationQuotedPrice.date
			? moment(stationQuotedPrice.date).format('M/D/YYYY')
			: '';

		return (
			<div className={classes.root}>
				<div className={classes.container}>
					<div className={classes.containerWrapper}>
						<img alt="Logo" className={classes.logo} src={pfLogo} />

						<div className={classes.bigInvoiceContainer}>
							<div className={classes.bigInvoice}>FORMULA</div>
							<div className={classes.billingInfo}>
								<div className={classes.formulaName}>
									E85 Pricing{station.name ? ` for ${station.name}` : ''}
								</div>
								{!!pricedDate && <div className={classes.formulaUpdated}>Priced {pricedDate}</div>}
							</div>
						</div>

						<div className={classes.itemSectionGeneric}>
							<div className={classes.labelLine}>
								<div className={classes.colDescription}>DESCRIPTION</div>
								<div className={classes.colQuantity}>VALUE</div>
							</div>

							{formulaRows.map((formulaRow, i) => {
								const { label, value, isSubtotal, isTotal, isTitle, notImplemented } = formulaRow;

								let className = 'itemRowGeneric';
								if (isSubtotal) {
									className = 'rowSubTotalGeneric';
								} else if (isTotal) {
									className = 'rowTotalGeneric';
								}

								let displayValue = value;
								if (_.isNumber(displayValue) && !_.isNaN(displayValue)) {
									displayValue = parseFloat(displayValue.toFixed(5)).toFixed(5);
								} else {
									displayValue = '???';
								}

								if (isTitle) {
									return (
										<div key={`fr${i}`} className={classes.rowTitleGeneric}>
											{label}
										</div>
									);
								} else if (notImplemented) {
									return (
										<div key={`fr${i}`} className={classes.itemRowGeneric}>
											<WarningIcon className={classes.warning} /> {label}
										</div>
									);
								} else {
									return (
										<div key={`fr${i}`} className={classes[className]}>
											<div className={classes.colDescription}>{label}</div>
											<div className={classes.colQuantity}>{displayValue}</div>
										</div>
									);
								}
							})}

							{!!formulaNotes.length && (
								<ul className={classes.formulaNotes}>
									{formulaNotes.map((note, i) => {
										return <li key={`fn${i}`}>{note}</li>;
									})}
								</ul>
							)}
						</div>

						<div className={classes.bottomSection}>
							<div className={classes.labelLine}>
								<div>Terms &amp; Conditions</div>
							</div>
							<div className={classes.termAndTotal}>
								<div className={classes.termParagraph}>- Prices do not include any taxes.</div>
							</div>
							<div className={classes.confidentialNote}>
								This pricing breakdown is strictly confidential. It is provided solely for the
								recipient&apos;s own use and may not be shared, copied, or disclosed to any third
								party without the prior written consent of Pearson Fuels.
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};
}

StationInvoice.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func,

	//- Batch
	publicGetStationInvoice: PropTypes.func,
	stationInvoice: PropTypes.object,
	stationQuotedPriceMap: PropTypes.object,
	dataDumpMap: PropTypes.object,
	stationMap: PropTypes.object,
	gasFormulaMap: PropTypes.object,
	rackFormulaMap: PropTypes.object,
};

export default _.flow([withStyles(styles), StationInvoiceContainer])(StationInvoice);
